<div class="box">
  @if (qrUrl) {
    <div class="description">PLEASE SCAN QR<br>AND PAY YOUR BILL</div>
    <img [src]="qrUrl" alt="">
  }
  <div class="subject">{{ tableName }}</div>
</div>
